var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_353_638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.965 13.9825C27.965 6.2602 21.7049 0 13.9825 0C6.2602 0 0 6.2602 0 13.9825C0 20.9616 5.1132 26.7462 11.7978 27.7952V18.0243H8.24752V13.9825H11.7978V10.902C11.7978 7.39761 13.8852 5.46194 17.0792 5.46194C18.609 5.46194 20.2091 5.73502 20.2091 5.73502V9.17603H18.446C16.709 9.17603 16.1673 10.2539 16.1673 11.3597V13.9825H20.0453L19.4253 18.0243H16.1673V27.7952C22.8518 26.7462 27.965 20.9616 27.965 13.9825Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4253 18.0243L20.0453 13.9825H16.1673V11.3596C16.1673 10.2538 16.709 9.176 18.446 9.176H20.2091V5.73499C20.2091 5.73499 18.609 5.46191 17.0792 5.46191C13.8852 5.46191 11.7978 7.39759 11.7978 10.902V13.9825H8.24753V18.0243H11.7978V27.7952C12.5205 27.9084 13.251 27.9652 13.9825 27.965C14.7258 27.965 15.4554 27.9069 16.1673 27.7952V18.0243H19.4253Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_353_638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.501951957b2e8b1590e790b47361867b.svg";
export { ForwardRef as ReactComponent };